import z from 'zod';
import { phoneSchema } from './others';

export const UserContactInfoSchema = z.object({
  address_line_1: z.string({ message: 'Enter your store address' }),
  address_line_2: z.string({ message: 'Enter a valid address' }).optional(),
  city: z.string({ message: 'Enter your store city' }),
  state: z.string({ message: 'Enter your store state' }),
  postal_code: z.string({ message: 'Enter your store postal code' }),
  country: z.string({ message: 'Enter your store country' }),
  default: z.boolean().optional(),
  receiver_name: z.string({
    message: "Enter the receiver's name for store deliveries",
  }),
  receiver_phone: z.string({
    message: "Enter the receiver's phone number for store deliveries",
  }),
  receiver_email: z
    .string({ message: 'Enter your a valid email' })
    .email({ message: 'Enter a valid receiver email for store deliveries' })
    .trim()
    .lowercase(),
  custom_label: z.string({ message: 'Enter a valid label' }).optional(),
});

export const UserAddressInfoSchema = z.object({
  address_line_1: z.string({ message: 'Enter your store address' }),
  address_line_2: z.string({ message: 'Enter a valid address' }).optional(),
  city: z.string({ message: 'Enter your store city' }).trim(),
  state: z.string({ message: 'Enter your store state' }).trim(),
  postal_code: z.string({ message: 'Enter your store postal code' }).optional(),
  country: z.string({ message: 'Enter your store country' }).trim(),
  default: z.boolean().optional(),
  // receiver_name: z.string({
  //   message: "Enter the receiver's name for store deliveries",
  // }),
  // receiver_phone: z.string({
  //   message: "Enter the receiver's phone number for store deliveries",
  // }),
  // receiver_email: z
  //   .string({ message: 'Enter your a valid email' })
  //   .email({ message: 'Enter a valid receiver email for store deliveries' }),
  custom_label: z.string({ message: 'Enter a valid label' }).optional(),
});

export const Primary_information = z.object({
  first_name: z.string({ message: 'Enter your first name' }).trim(),
  last_name: z.string({ message: 'Enter your last name' }).trim(),
  email: z
    .string({ message: 'Enter your email address' })
    .email({ message: 'Enter a valid email address' })
    .trim()
    .lowercase(),
  phone: phoneSchema,
  additional_info: z
    .string({ message: 'Enter additional information' })
    .optional(),
  date_of_birth: z.string({ message: 'Enter your date of birth' }).optional(),
  middle_name: z.string({ message: 'Enter your middle name' }).optional(),
  secondary_email: z
    .string({ message: 'Enter a valid secondary email address' })
    .email({ message: 'Enter a valid email' })
    .trim()
    .lowercase(),
  secondary_phone: phoneSchema.optional(),
});

export const Secondary_information = z.object({
  website: z
    .string({ message: 'Enter a website' })
    .url({ message: 'Enter a valid website URL' })
    .trim()
    .optional(),
  user_name: z.string({ message: 'Enter a valid username' }).trim().optional(),
  short_bio: z
    .string({ message: 'Enter a valid secondary email address' })
    .trim()
    .optional(),
});

export const UserInformationSchema = z.object({
  primary_information: Primary_information,
  secondary_information: Secondary_information,
});

export const UserContactInformationAccordionSchema = z.object({
  primary_information: z.object({
    middle_name: z
      .string({ message: 'Enter your middle name' })
      .trim()
      .optional(),
    date_of_birth: z.string({ message: 'Enter your date of birth' }).optional(),
    secondary_email: z
      .email({ message: 'Enter a valid email' })
      .trim()
      .lowercase()
      .optional(),
    secondary_phone: phoneSchema.optional(),
    additional_info: z
      .string({ message: 'Enter additional information' })
      .optional(),
  }),
  secondary_information: z.object({
    user_name: z
      .string({ message: 'Enter a valid username' })
      .trim()
      .optional(),
    website: z.url({ message: 'Enter a valid website URL' }).trim().optional(),
    short_bio: z
      .string({ message: 'Enter a valid short bio' })
      .trim()
      .optional(),
  }),
});
